<div
  class="col-auto position-relative"
  (window:resize)="onWindowResize()"
>
  <button
    id="btn-filter"
    class="btn btn-std-outline btn-advance-search round-input text-dark-gray"
    title="{{ 'MEMOS.ADVANCE-SEARCH.Advanced search' | translate }}"
    type="button"
    (click)="filterToggle()"
  >
    <svg-icon
      src="assets/images/icons/graphics/sliders-h.svg"
      id="btn-filter"
      class="d-flex align-items-center justify-content-center pointer text-gray-pantone"
      [svgClass]="'icon-size-res'"
      [svgStyle]="{ stroke: 'currentColor' }"
    >
    </svg-icon>
  </button>
  @if (showFilter) {
    <div class="width-box text-start">
      <div
        class="box-header border-bottom"
        (clickOutside)="handleClickOutside($event)"
      >
        <div class="p-3 d-flex">
          <svg
            (click)="clearSearchFilter()"
            class="me-3 d-md-none"
            stroke="#000000"
            stroke-width="1.5"
            xmlns="http://www.w3.org/2000/svg"
            height="22"
            width="22"
            viewBox="0 0 24 24"
          >
            <use
              href="assets/images/icons/arrows/arrow-left.svg#arrow-left"
            ></use>
          </svg>
          <h3 class="fs-base-u5 fw-bold m-0">
            {{ 'COMMON.Filter' | translate }}
          </h3>
        </div>
        <button
          class="btn btn-std-outline-black-light btn-icon mx-3 d-none d-md-block"
          type="button"
          (click)="clearSearchFilter()"
        >
          <span class="far fa-times fa-lg"></span>
        </button>
      </div>
      <div id="popupFilter" class="box-detail">
        <div class="d-md-none mb-3 d-flex align-items-center">
          <svg
            class="me-3"
            stroke="currentColor"
            stroke-width="1.5"
            xmlns="http://www.w3.org/2000/svg"
            height="22"
            width="22"
            viewBox="0 0 24 24"
          >
            <use
              href="assets/images/icons/objects/search.svg#search"
            ></use>
          </svg>
          <h3 class="fs-base-u5 fw-bold m-0">
            {{ 'MEMOS.Search filters' | translate }}
          </h3>
        </div>
        @if (customBodyFilter) {
          <ng-container
            [ngTemplateOutlet]="customBodyFilter.templateRef"
          ></ng-container>
        }
        <div
          id="btn-footer"
          class="d-flex align-items-center justify-content-end mt-3 btn-footer"
        >
          <button
            class="btn btn-std btn-height-std btn-std-2ry fs-base-l4 mx-1 py-base-l8"
            type="button"
            (click)="clearSearchFilter()"
          >
            {{ 'LOG.CLEAR' | translate }}
          </button>
          <button
            class="btn btn-std btn-height-std btn-std-prim fs-base-l4 mx-1 py-base-l8"
            type="button"
            (click)="searchFilter()"
          >
            {{ 'DASHBOARD.SEARCH' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
